import initSearchForm from "./searchForm";

export default initSearchForm;
